 
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TasksService {
  constructor(private httpClient: HttpClient) {}

  addTask(task) {
    const payload = { task };
    return this.httpClient.post('/api/v1/tasks', payload);
  }

  updateTask(rid, task) {
    rid = rid.replace('#', '');
    const payload = {
      rid,
      task
    };
    return this.httpClient.put(`/api/v1/tasks/${rid}`, payload);
  }

  markCompleted(mark, rid) {
    const payload = {
      completed: mark,
      rid
    };
    return this.httpClient.post(`/api/v1/tasks/${rid}/completed`, payload);
  }

  deleteTask(rid) {
    rid = rid.replace('#', '');
    return this.httpClient.delete(`/api/v1/tasks/${rid}`);
  }
  merge(rid) {
    const payload = {
      rid
    };
    return this.httpClient.post(`/api/v1/git/vertex/merge/${rid}`, payload);
  }

  rejectReason(rid, obj) {
    const payload = {
      formData: obj,
      rid
    };
    return this.httpClient.put(`/api/v1/git/pull_request/reject/${rid}`, payload);
  }

  deployVertex(rid) {
    const payload = {
      key: rid,
    };
    return this.httpClient.post(`/api/v1/git/vertex/deploy/${rid}`, payload);
  }

  getTodotaskList(todoRequestParams?) {
    return this.httpClient.get<any>('/api/v1/user/dashboard/section/todo', { params: todoRequestParams });
  }
}
